import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/mendeley': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M320.1 180.5H320.7C355.4 180.5 383.5 208.6 383.5 243.3 383.5 268.3 364.3 306.1 320.7 306.1H320.1C276.7 306.1 257.3 268.6 257.3 243.3 257.3 208.6 285.5 180.5 320.1 180.5M54.2 433.1C101.3 439 135.8 390.2 115.4 345.3 68.1 241.6 301.3 239.2 261.9 337.1 261.8 337.2 261.7 337.3 261.6 337.5 234.8 380.3 268.4 434.9 320.4 432.7 372.5 434.8 405.8 380.1 379.2 337.5 379.1 337.3 379 337.2 378.9 337.1 339.5 239.2 572.7 241.6 525.4 345.3 520.8 355.3 518.7 366.6 519.7 378.3 524.6 431.7 588.4 452.4 624.6 413.5 642.4 398.7 647.7 347.9 624.6 325.2 612.3 312.8 594.9 306 576.2 308 532.9 307 526.5 273.1 538.7 209.2 561.5 151.7 523.8 77.7 451.3 78.4 373.9 79.1 369.6 160.4 320.4 160.4 272.3 160.4 266.4 79.1 189.5 78.4 116.6 77.6 79.4 151.7 102.1 209.2 114.3 273.1 107.9 307 64.6 308 43.4 305.7 27.6 314.5 11.6 330.5-8.3 350.2-7.7 425.3 54.2 433.1'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/mendeley.js
// module id = wK6o
// module chunks = 144